module.exports = __webpack_public_path__ + "img/Georgie-Tilt.3c41dad3.jpeg";